import {Injectable} from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {Airline} from '../../interfaces/Airline';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {AirlineParams} from '../../interfaces/AirlineParams';
import {ObjectMapService} from '../../../utilities/services/object-map/object-map.service';
import {PaginationAbstractService} from '../../../utilities/services/pagination-abstract/pagination-abstract.service';


@Injectable()
export class AirlineService extends PaginationAbstractService<Airline, AirlineParams> {

    private route = 'airline';

    protected _airlines: { [id: number]: Airline } = {};

    constructor(private http: AuthHttp, private objMapService: ObjectMapService) {
        super(objMapService, 'airlineParams');
    }


    public getAirlines(params?: AirlineParams): Promise<Pagination<Airline>> {
        return this.getPagination(params).toPromise();
    }

    public getAllAirlines(): Promise<Pagination<Airline>> {
        return this.http
            .get(`${environment.baseUrl}${this.route}?limit=9999&page=1`)
            .map((res) => res.json()).toPromise();
    }

    protected prefetch() {
        return this.http.get(`${environment.baseUrl}${this.route}`, {params: this._params})
            .map((res) => res.json())
            .do(pagination => {
                this._airlines = {};
                pagination.data.forEach(item => this._airlines[item.id] = item);
            })
    }

    public getAirline(id): Promise<Airline> {
        if (this._airlines[id])
            return Promise.resolve(this._airlines[id]);
        return this.http.get(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
    }

    public update(airline: Airline) {
        this.clearCache();
        this.purgeAirlineFromCache(airline.id);
        return this.http.put(`${environment.baseUrl}${this.route}/${airline.id}`, airline).toPromise();
    }


    public create(airline: Airline) {
        this.clearCache();
        return this.http.post(`${environment.baseUrl}${this.route}`, airline).map((res) => res.json())
            .do((airlineR: Airline) => this._airlines[airlineR.id] = airlineR)
            .toPromise();
    }


    public delete(id) {
        this.clearCache();
        this.purgeAirlineFromCache(id);
        return this.http.delete(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
    }

    protected purgeAirlineFromCache(id) {
        if (this._airlines[id])
            delete this._airlines[id];
    }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airline/services/airline/airline.service.ts